import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";
import { useLocalizedLinks } from "@/hooks/useLocale";

const FOOTER_NAV = [
  { key: "nav.home", to: "/" },
  { key: "nav.categories", to: "/#categories" },
  { key: "nav.resources", to: "/#resources" },
  { key: "nav.guides", to: "/#guides" },
  { key: "nav.safety", to: "/#safety" },
  { key: "nav.faq", to: "/#faq" },
];

export default function Footer() {
  const { t } = useTranslation();
  const { to: linkTo } = useLocalizedLinks();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-layout-grid-line text-lg text-background-50"></i>
              </span>
              <span className="font-heading text-lg font-bold">{t("brand")}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-100/80">{t("footer.tagline")}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50">
              {t("footer.navTitle")}
            </h4>
            <ul className="mt-4 space-y-2.5">
              {FOOTER_NAV.map((link) => (
                <li key={link.key}>
                  <Link
                    to={linkTo(link.to)}
                    className="text-sm text-background-100/80 transition-colors hover:text-background-50"
                  >
                    {t(link.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50">
              {t("footer.categoriesTitle")}
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5 sm:grid-cols-3">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-100/80 transition-colors hover:text-background-50"
                  >
                    {t(`categories.items.${cat.id}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-background-50/15 pt-6">
          <p className="text-xs leading-relaxed text-background-100/60">{t("footer.disclaimer")}</p>
          <p className="mt-4 text-xs text-background-100/60">
            © {year} {t("brand")}. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}